import { InverseBoldMatch } from "@faire/prototype-playground/components/shared/InverseBoldMatch";
import React from "react";

import { formatOrderedDate, type MockReorderedProduct } from "./mockProducts";

interface IProps {
  product: MockReorderedProduct;
  query: string;
  now: Date;
}

export const ReorderedProductRow: React.FC<IProps> = ({
  product,
  query,
  now,
}) => (
  <div className="group hover:bg-fs-surface-secondary flex cursor-pointer items-center gap-(--slate-spacing-element-large) px-(--slate-spacing-element-large) py-(--slate-spacing-element-default)">
    <img
      src={product.imageUrl}
      alt=""
      className="h-16 w-16 shrink-0 rounded-(--slate-dimensions-1) object-cover"
    />
    <div className="flex min-w-0 flex-col">
      <span className="type-fs-label-medium text-fs-text-subdued mb-0.5">
        Ordered {formatOrderedDate(product.lastOrderedAt, now)}
      </span>
      <span className="type-fs-paragraph-medium text-fs-text-primary truncate">
        <InverseBoldMatch text={product.name} query={query} />
      </span>
      <span className="type-fs-paragraph text-fs-text-subdued">
        {product.brandName}
      </span>
    </div>
  </div>
);
